import { useShowCause } from 'core/Api';
import { CauseLogo } from 'core/Components';
import { useCrowdFundingTranslations } from 'core/Hooks';
import { useAtomValue } from 'jotai';
import { Center, Group, Header, Skeleton, Text } from 'ui';

import { donationCauseIdAtom } from '../../Context/donations/donationsCheckout.provider';

export const MobileCauseHeader = ({ position }: { position?: 'absolute' | 'fixed' }) => {
  const donationCauseId = useAtomValue(donationCauseIdAtom);
  const { data: cause, isLoading } = useShowCause(donationCauseId ?? undefined);
  const { t } = useCrowdFundingTranslations(donationCauseId);

  return (
    <Header h={'75px'} pos={position ?? 'fixed'} bg="transparent" withBorder={false}>
      <Group wrap="nowrap" h="100%" p="md" mt="xs">
        <CauseLogo size="sm" cause_uuid={donationCauseId} />

        <Center>
          <Skeleton visible={isLoading}>
            <Text fw={600} c="white">
              {`${t('Donate')} to ${cause?.name}`}
            </Text>
          </Skeleton>
        </Center>
      </Group>
    </Header>
  );
};
